export default __webpack_public_path__ + "static/media/strogoff.09d4edbc.png";